<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <!-- <h4>Mağaza Seçimi</h4> -->
      </v-col>
      <v-col cols="12" md="3" sm="3" style="margin-top: 24px;">
        <v-select
          :items="allVenueNameList"
          item-text="venueName"
          v-model="venueId"
          item-value="id"
          label="Mağaza Adı"
          data-vv-name="select"
          required
        ></v-select>
      </v-col>
      <v-col cols="12" md="3" sm="3">
        <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="startDate.date"
              clearable
              label="Başlangıç tarihi"
              readonly
              v-on="on"
              style="margin-top: 28px;"
              @click:clear="clearStartDate"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate.originDate"
            :max="new Date().toISOString().substr(0, 10)"
            @change="
              filterByDateChange(startDate.originDate, endDate.originDate)
            "
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" sm="3">
        <v-menu v-model="menu3" :close-on-content-click="false" max-width="290">
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="endDate.date"
              clearable
              label="Bitiş tarihi"
              readonly
              v-on="on"
              style="margin-top: 28px;"
              @click:clear="clearEndDate"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate.originDate"
            :min="nowDate"
            :disabled="datePickerDisable"
            :max="new Date().toISOString().substr(0, 10)"
            @change="
              filterByDateChange(startDate.originDate, endDate.originDate)
            "
            @input="menu3 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" sm="3">
        <v-btn
          color="#4d48f9"
          style="
            text-transform: none !important;
            color: white;
            margin-top: 35px;
            margin-left: 4px;
          "
          @click="exportVenueReports()"
        >
          EXPORT
        </v-btn>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        Mağaza Satışları
        <v-spacer></v-spacer>
        <v-text-field
          v-model="venuePageData.search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
          @input="searchVenueReport"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="allVenueReports"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <!-- <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="routeCompanyEdit(item)">mdi-pencil</v-icon>
        </template>-->
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="venuePageData.pageNumber"
          :color="'#4d48f9'"
          :length="pagination.pagesLength"
          @input="setPageNumber"
        ></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'OrderReports',
  data: () => ({
    // search: "",
    startDate: {
      date: new Date().toISOString().substr(0, 10),
      originDate: new Date().toISOString().substr(0, 10),
    },
    endDate: {
      date: new Date().toISOString().substr(0, 10),
      originDate: new Date().toISOString().substr(0, 10),
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    venueId: null,
    nowDate: '',
    datePickerDisable: true,
    venuePageData: {
      pageNumber: 1,
      pageSize: 10,
      search: '',
      startDate: null,
      endDate: null,
    },
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    headers: [
      {
        text: 'Firma Adı',
        value: 'companyName',
        align: 'start',
        sortable: false,
      },
      { text: 'Mağaza Adı', value: 'venueName', sortable: false },
      { text: 'Mağaza Adresi', value: 'venueAddress', sortable: false },
      { text: 'Mağaza Katılma Tarihi', value: 'createDate', sortable: false },
      {
        text: 'Verilen Toplam Sipariş Sayısı',
        value: 'salesCount',
        sortable: false,
      },
      { text: 'Uzaktan Sipariş', value: 'remoteOrderCount', sortable: false },
      { text: 'Hemen Al', value: 'cashierFrontOrderCount', sortable: false },
      {
        text: 'Sipariş Veren Toplam Kullanıcı Sayısı',
        value: 'coffeeUserCount',
        sortable: false,
      },
    ],
  }),
  computed: mapGetters(['allVenueReports', 'allVenueNameList', 'loading']),

  watch: {
    'startDate.originDate': function () {
      this.nowDate = this.startDate.originDate
      this.datePickerDisable = false
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
  },
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1
    this.venuePageData.pageNumber = Number(page)

    this.getVenueReports(this.venuePageData).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
    this.getVenueNameList()
  },
  mounted() {
    this.startDate.originDate = this.startDate.date
    this.startDate.date = this.formatDate(this.startDate.date)
    this.endDate.originDate = this.endDate.date
    this.endDate.date = this.formatDate(this.endDate.date)
  },
  methods: {
    ...mapActions([
      'getVenueReports',
      'getVenueNameList',
      'getVenueExportReports',
    ]),
    //Data table item per page changed function
    getItemPerPage(val) {
      this.venuePageData.pageSize = val
      this.venuePageData.pageNumber = 1
      this.getVenueReports(this.venuePageData).then((response) => {
        this.pagination.pagesLength = response.totalPages
      })
    },
    searchVenueReport(val) {
      if (val.length > 2) {
        this.venuePageData.search = val;
        this.getVenueReports(this.venuePageData).then((response) => {
          this.pagination.totalItems = response.totalCount
          this.pagination.pagesLength = response.totalPages
        })
      }
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.venuePageData.pageNumber = val
      if (val !== 1) {
        this.$router.push({ query: { page: val } })
      }
      this.getVenueReports(this.venuePageData)
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({ path: this.$route.fullPath, query: { page: val } })
    },
    exportVenueReports() {
      const startDate = this.startDate.originDate
      const endDate = this.endDate.originDate

      let exportObject = {
        venueId: this.venueId,
        endDate: this.endDate.originDate,
        startDate: this.startDate.originDate,
      }

      if (
        (startDate != null && endDate == null) ||
        (startDate == null && endDate != null)
      ) {
        alert(
          'Başlangıç ve bitiş tarihlerinden birisi girilmişse diğeride girilmek zorundadır',
        )
      } else if (startDate != null && endDate != null && startDate > endDate) {
        alert('Başlangıç tarihi bitiş tarihinden büyük olamaz')
      } else {
        if (startDate != null) {
          let startDateExpression = startDate.split(/[- :]/)
          let dateTime =
            startDateExpression[2] +
            '-' +
            startDateExpression[1] +
            '-' +
            startDateExpression[0]
          exportObject.startDate = dateTime
        }
        if (endDate != null) {
          let endDateExpression = endDate.split(/[- :]/)
          let dateTime =
            endDateExpression[2] +
            '-' +
            endDateExpression[1] +
            '-' +
            endDateExpression[0]
          exportObject.endDate = dateTime
        }
        // console.log("export object",exportObject);
        this.getVenueExportReports(exportObject)
      }
    },
    filterByDateChange(startDate, endDate) {
      this.startDate.originDate = startDate
      this.endDate.originDate = endDate

      this.startDate.date = this.formatDate(startDate)
      this.endDate.date = this.formatDate(endDate)

      if (startDate !== null) {
        startDate = startDate.split(/[- :]/)
        this.venuePageData.startDate =
          startDate[2] + '-' + startDate[1] + '-' + startDate[0]
      }

      if (endDate !== null) {
        endDate = endDate.split(/[- :]/)
        this.venuePageData.endDate =
          endDate[2] + '-' + endDate[1] + '-' + endDate[0]
      }

      this.venuePageData.pageNumber = 1
      this.getVenueReports(this.venuePageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    clearStartDate() {
      this.startDate.originDate = null
      this.startDate.date = null
    },
    clearEndDate() {
      this.endDate.originDate = null
      this.endDate.date = null
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
  },
}
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}
.v-data-footer__icons-after {
  display: none;
}
</style>
